import { Spinner } from "@myhealth-raccoon/components";
import React from "react";
import { Outlet, useNavigation } from "react-router-dom";

export function LoadingScreen({ children }: React.PropsWithChildren) {
    const navigation = useNavigation();

    if (navigation.state === 'idle') {
        return <><Outlet />{children}</>
    };
    return <Spinner className="absolute inset-0 flex items-center justify-center" />
}